<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container modal-container-sm object-modal-container person-modal-container border-black">
          <div class="modal-header">
            <button class="close btn  btn-light pull-right" @click="$emit('close')"><i class="fa fa-close"></i></button>
          </div>
          <div class="modal-body person-modal-body">
            <div class="row">
              <div class="col-xs-12 col-sm-4">
                <div>
                  <div><b>UBC Learning Exchange</b></div>
                  <div>612 Main Street</div>
                  <div>
                    <span>Vancouver</span>, <span>BC</span>
                  </div>
                  <div>
                    <span>Canada</span> <span>V6A 2V3</span>
                  </div>
                  <div>Tel 604 827 2777</div>
                  <div>Fax 604 682 6807</div>
                </div>
              </div>
              <div class="col-xs-12 col-sm-8">
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2602.8513970090794!2d-123.10150318421586!3d49.27921297893735!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548671701b4105f9%3A0xa3627214acd74b9e!2s612%20Main%20St%2C%20Vancouver%2C%20BC%20V6A%202V3!5e0!3m2!1sen!2sca!4v1569440793014!5m2!1sen!2sca" width="100%" height="250" frameborder="0" style="border:0;" allowfullscreen=""></iframe>
              </div>
            </div>
            <div class="row">
              <div class="col-xs-12 text-center">
                <div class="margin-top-20">
                  <b>Please print citation and bring it with you to the location above.</b>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn  btn-dark" v-on:click="printCitation($event)">Print Citation</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  export default {
    methods: {
      printCitation: function(e){
        e.preventDefault();
        let citation = require('../../../citation.js');
        citation.printCitation();
      }
    }
  }
</script>
